import { render } from "./Conversation.vue?vue&type=template&id=1009de92&scoped=true"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"

import "./Conversation.vue?vue&type=style&index=0&id=1009de92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1009de92"]])

export default __exports__